
<div class="my-3" [ngClass]="{'withImage' : header.image}">
  <div class="row align-items-center">
    <div class="col-12 col-md-auto">
      <h1 *ngIf="!header.image" class="imageImitation">
        <span [ngClass]="{'reverse': header.reverse !== false}" [innerHTML]="replace(header.title)"></span>
      </h1>
      <h1 *ngIf="header.image" class="headerBg headerBg--{{ background }}">
        <img [src]="header.image" alt="{{ header.title }}">
      </h1>
    </div>
    <div class="col">
      <p *ngIf="header.text" [innerHTML]="header.text"></p>
    </div>
  </div>
</div>
